import { z } from "zod";

/**
 * Каталог задач очереди (pg-boss). Имена и схемы: этап 1, обработчики: по этапам.
 * Правило: отложенная задача при запуске заново читает состояние из базы, а не доверяет данным
 * на момент постановки.
 */
export const JobSchemas = {
  /** Ответ бота на всё накопившееся в диалоге. singletonKey = conversationId, задержка 2–3 с. Этап 3. */
  "assistant.reply": z.object({ conversationId: z.string() }),
  /** Отправить исходящее в канал. Этап 3 (web) / 4 (instagram). */
  "channel.send": z.object({ messageId: z.string() }),
  /** Расшифровать голосовое и положить текст в сообщение. Этап 4. */
  transcribe: z.object({ messageId: z.string(), attachmentUrl: z.string() }),
  /** Снять истёкшее удержание. Этап 2. */
  "hold.expire": z.object({ bookingId: z.string() }),
  /** Автоподтверждение, если мастер не ответил в срок. Этап 2. */
  "booking.auto_confirm": z.object({ bookingId: z.string() }),
  /** Вернуть бота в диалог после молчания мастера. Этап 1 (inbox). */
  "conversation.bot_resume": z.object({ conversationId: z.string() }),
  /** Доставить уведомление (push/почта). Этап 5. */
  "notify.deliver": z.object({ notificationId: z.string() }),
  /** Месячная сводка владельцу. Этап 5. */
  "report.monthly": z.object({ salonId: z.string(), month: z.string() }),
  /** Расписание: продление токенов Instagram раз в сутки. Этап 4. */
  "channel.refresh_tokens": z.object({}),
  /** Расписание: удаление старых данных. Этап 7. */
  "data.cleanup": z.object({}),
} as const;

export type JobName = keyof typeof JobSchemas;
export type JobPayload<N extends JobName> = z.infer<(typeof JobSchemas)[N]>;
export const JobNames = Object.keys(JobSchemas) as JobName[];

/** Расписания (cron в поясе UTC); регистрирует воркер при старте. */
export const JobSchedules: ReadonlyArray<{ name: JobName; cron: string }> = [
  { name: "channel.refresh_tokens", cron: "15 3 * * *" },
  { name: "data.cleanup", cron: "45 3 * * *" },
];
